import { render } from "./Backup.vue?vue&type=template&id=c2309b84&scoped=true"
import script from "./Backup.vue?vue&type=script&lang=js"
export * from "./Backup.vue?vue&type=script&lang=js"

import "./Backup.vue?vue&type=style&index=0&id=c2309b84&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2309b84"]])

export default __exports__